import { FC, memo } from "react";
import ReactPlayer from "react-player/lazy";
import { Zenitho } from "uvcanvas";
import { IUseTasteTestPersonalization } from "../../../hooks/taste-test/useTasteTestPersonalization";
import { getFileType } from "../../../utils/taste-test.utils";

interface ITasteTestBannerImageProps {
  tasteTestPersonalization?: IUseTasteTestPersonalization;
}

const TasteTestBannerImage: FC<ITasteTestBannerImageProps> = ({ tasteTestPersonalization }) => {
  const bannerFileType = getFileType(tasteTestPersonalization?.bannerImage);

  if (bannerFileType === "unknown") {
    return <Zenitho />;
  }

  if (bannerFileType === "image") {
    return (
      <div
        className="h-full w-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${tasteTestPersonalization?.bannerImage})`,
        }}
      />
    );
  }

  if (bannerFileType === "video") {
    return (
      <div className="relative h-full w-full">
        <ReactPlayer
          url={tasteTestPersonalization?.bannerImage}
          className="absolute left-0 top-0 h-full w-full"
          width="100%"
          height="auto"
          playing
          loop
          muted
          playsinline
          controls={false}
        />
      </div>
    );
  }

  return null;
};

export default memo(TasteTestBannerImage);
